


export const cleanNameField = (name: string | null | undefined): string => {
  console.log('🔍 cleanNameField input:', { 
    name, 
    type: typeof name, 
    stringified: JSON.stringify(name) 
  });
  
  if (!name) return '';
  
  // Simple clean - just trim whitespace and handle null/undefined
  let cleaned = name.trim();
  
  // Only handle completely empty or purely numeric strings that are clearly not names
  if (cleaned === '0' || cleaned === '\0' || /^0+$/.test(cleaned)) {
    return '';
  }
  
  console.log('🔍 cleanNameField output:', { 
    input: name, 
    output: cleaned 
  });
  
  return cleaned;
};

export const getDisplayName = (user: any) => {
  console.log('🔍 getDisplayName raw user object fields:', {
    userId: user.id,
    allUserKeys: Object.keys(user),
    firstName: user.first_name,
    lastName: user.last_name,
    username: user.username,
    isActive: user.is_active,
    isSuperuser: user.is_superuser,
    roleNames: user.role_names
  });
  
  const firstName = cleanNameField(user.first_name);
  const lastName = cleanNameField(user.last_name);
  
  console.log('🔍 getDisplayName after cleaning:', {
    userId: user.id,
    rawFirst: user.first_name,
    rawLast: user.last_name,
    cleanedFirst: firstName,
    cleanedLast: lastName,
    finalName: firstName || lastName ? `${firstName} ${lastName}`.trim() : user.username
  });
  
  if (firstName || lastName) {
    return `${firstName} ${lastName}`.trim();
  }
  
  return user.username;
};

export const getInitials = (user: any) => {
  console.log('🔍 getInitials input:', {
    userId: user.id,
    firstName: user.first_name,
    lastName: user.last_name,
    username: user.username
  });
  
  const firstName = cleanNameField(user.first_name);
  const lastName = cleanNameField(user.last_name);
  
  let initials;
  if (firstName || lastName) {
    const first = firstName?.charAt(0) || '';
    const last = lastName?.charAt(0) || '';
    initials = (first + last).toUpperCase() || user.username.charAt(0).toUpperCase();
  } else {
    initials = user.username.substring(0, 2).toUpperCase();
  }
  
  console.log('🔍 getInitials output:', {
    userId: user.id,
    firstName,
    lastName,
    finalInitials: initials
  });
  
  return initials;
};

export const getProfileImageUrl = (user: any) => {
  if (user.profile_image) {
    if (user.profile_image.startsWith('http')) {
      return user.profile_image;
    }
    return `https://api.at-work.biz/public/profile_photos/${user.profile_image}`;
  }
  return undefined;
};


